import { Navigate, useParams } from 'react-router-dom';
import { FUTURES_MODE_SCREENS } from '../../features/futures/modes';

const VALID_MODES = new Set(['high-low', 'up-down', 'high-low-spread', 'tap-trading']);

export function FuturesPage() {
  const params = useParams();
  const activeFuturesMode = typeof params.mode === 'string' ? params.mode : 'high-low';

  if (!VALID_MODES?.has(activeFuturesMode)) {
    return <Navigate to="/futures/high-low" replace />;
  }

  const ModeScreen = FUTURES_MODE_SCREENS[activeFuturesMode];

  if (!ModeScreen) {
    return <Navigate to="/futures/high-low" replace />;
  }

  return <ModeScreen />;
}
